import axios from 'axios';

const axiosInterceptors = axios.create();

axiosInterceptors.interceptors.request.use(
  (config) => {
    const accessToken = localStorage.ACCESS_TOKEN;

    if (accessToken) {
      config.headers.Authorization = `Bearer ${accessToken}`;
    }

    return config;
  },
  (error) => {
    Promise.reject(error);
  },
);

axiosInterceptors.interceptors.response.use(
  (response) => response,
  async (error) => {
    const { response, config } = error;
    const originalRequest = config;

    if (
      error.response.status === 401 &&
      originalRequest.url === 'api/auth/refreshToken'
    ) {
      return Promise.reject(error);
    }

    if (response.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;

      try {
        const res = await axiosInterceptors.post('api/auth/refreshToken', {
          refreshToken: localStorage.REFRESH_TOKEN,
        });

        const { accessToken, refreshToken } = res.data || {};

        localStorage.ACCESS_TOKEN = accessToken;
        localStorage.REFRESH_TOKEN = refreshToken;

        axios.defaults.headers.common.Authorization = `Bearer ${localStorage.ACCESS_TOKEN}`;

        return axiosInterceptors(originalRequest);
      } catch (err) {
        return Promise.reject(err);
      }
    } else {
      return Promise.reject(error);
    }
  },
);

export { axiosInterceptors };
